import { colours, device, laptopMediaQuery } from "@helpers";
import styled from "styled-components";

const FormError = styled.div`
  font-family: var(--euclid-regular);
  color: ${colours.ERROR};
  font-size: 12px;
  padding-top: 5px;
  height: 24px;

  ${laptopMediaQuery} {
    font-size: 14px;
  }

  @media (min-width: ${device.laptop}) and (max-width: ${device.desktopS}) {
    font-size: 14px;
    height: 41px;
  }

  @media (min-width: ${device.desktopS}) {
    height: 60px;
    font-size: 20px !important;
  }
`;

export default FormError;
